// 移动端工具函数

/**
 * 检测是否为移动设备
 * @returns {boolean}
 */
export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

/**
 * 检测是否为iOS设备
 * @returns {boolean}
 */
export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

/**
 * 检测是否为Android设备
 * @returns {boolean}
 */
export const isAndroid = () => {
  return /Android/i.test(navigator.userAgent);
};

/**
 * 获取屏幕尺寸类型
 * @returns {string} - 'mobile' | 'tablet' | 'desktop'
 */
export const getScreenSize = () => {
  const width = window.innerWidth;
  if (width < 768) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
};

/**
 * 检测是否为横屏模式
 * @returns {boolean}
 */
export const isLandscape = () => {
  return window.innerWidth > window.innerHeight;
};

/**
 * 检测是否支持触摸
 * @returns {boolean}
 */
export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

/**
 * 防止iOS Safari缩放
 */
export const preventIOSZoom = () => {
  if (isIOS()) {
    document.addEventListener('gesturestart', (e) => {
      e.preventDefault();
    });
    document.addEventListener('gesturechange', (e) => {
      e.preventDefault();
    });
    document.addEventListener('gestureend', (e) => {
      e.preventDefault();
    });
  }
};

/**
 * 设置安全区域CSS变量
 */
export const setSafeAreaVars = () => {
  if (isIOS()) {
    const root = document.documentElement;
    root.style.setProperty('--safe-area-inset-top', 'env(safe-area-inset-top)');
    root.style.setProperty('--safe-area-inset-bottom', 'env(safe-area-inset-bottom)');
    root.style.setProperty('--safe-area-inset-left', 'env(safe-area-inset-left)');
    root.style.setProperty('--safe-area-inset-right', 'env(safe-area-inset-right)');
  }
};

/**
 * 添加触摸反馈
 * @param {HTMLElement} element 
 */
export const addTouchFeedback = (element) => {
  if (!isTouchDevice()) return;
  
  element.addEventListener('touchstart', () => {
    element.style.opacity = '0.8';
    element.style.transform = 'scale(0.98)';
  });
  
  element.addEventListener('touchend', () => {
    element.style.opacity = '';
    element.style.transform = '';
  });
  
  element.addEventListener('touchcancel', () => {
    element.style.opacity = '';
    element.style.transform = '';
  });
};

/**
 * 初始化移动端优化
 */
export const initMobileOptimization = () => {
  // 防止iOS缩放
  preventIOSZoom();
  
  // 设置安全区域变量
  setSafeAreaVars();
  
  // 添加设备类型到body类名
  const body = document.body;
  if (isMobile()) body.classList.add('mobile-device');
  if (isIOS()) body.classList.add('ios-device');
  if (isAndroid()) body.classList.add('android-device');
  if (isTouchDevice()) body.classList.add('touch-device');
  
  // 监听屏幕方向变化
  window.addEventListener('orientationchange', () => {
    setTimeout(() => {
      const orientation = isLandscape() ? 'landscape' : 'portrait';
      body.className = body.className.replace(/orientation-\w+/, '');
      body.classList.add(`orientation-${orientation}`);
    }, 100);
  });
  
  // 初始化方向类名
  const orientation = isLandscape() ? 'landscape' : 'portrait';
  body.classList.add(`orientation-${orientation}`);
};

/**
 * 动态调整表格列宽
 * @param {HTMLElement} tableElement 
 */
export const adjustTableForMobile = (tableElement) => {
  if (!isMobile()) return;
  
  const screenSize = getScreenSize();
  const columns = tableElement.querySelectorAll('th');
  
  if (screenSize === 'mobile') {
    columns.forEach((col, index) => {
      // 隐藏不重要的列
      if (index > 3) {
        col.style.display = 'none';
        const correspondingCells = tableElement.querySelectorAll(`td:nth-child(${index + 1})`);
        correspondingCells.forEach(cell => cell.style.display = 'none');
      }
    });
  }
};

const mobileUtils = {
  isMobile,
  isIOS,
  isAndroid,
  getScreenSize,
  isLandscape,
  isTouchDevice,
  preventIOSZoom,
  setSafeAreaVars,
  addTouchFeedback,
  initMobileOptimization,
  adjustTableForMobile
};

export default mobileUtils; 